/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default [

  {
    header: 'User',
    icon  : 'PackageIcon',
    i18n  : 'user',
    items : [
      {
        url    : null,
        name   : 'Dashboard',
        icon   : 'HomeIcon',
        i18n   : 'dashboard',
        permission: 'dashboard',
        companyPermission: 'company_can_use_dashboard',
        submenu: [
          {
            url : '/dashboard/registration-status',
            name: 'Registration Status',
            i18n: 'registration_status',
            slug: 'dashboard.registration_status'
          },
          {
            url : '/dashboard/announcements',
            name: 'Announcements',
            i18n: 'announcements',
            slug: 'dashboard.announcements'
          }
        ]
      },
      {
        url    : null,
        name   : 'Configuration',
        icon   : 'SettingsIcon',
        i18n   : 'configuration',
        permission: 'configurations',
        companyPermission: 'company_can_use_configuration',
        submenu: [
          {
            url : '/configuration/caller-id',
            name: 'Caller ID',
            i18n: 'caller_id',
            slug: 'configuration.caller_id'
          },
          {
            url    : null,
            name   : 'Members',
            i18n   : 'members',
            slug: 'configuration.members',
            submenu: [
              {
                url : '/configuration/members/groups',
                name: 'Group',
                i18n: 'groups',
                slug: 'configuration.members.groups'
              },
              {
                url : '/configuration/members/levels',
                name: 'Levels',
                i18n: 'levels',
                slug: 'configuration.members.levels'
              },
              {
                url : '/configuration/members/custom-fields',
                name: 'Custom Fields',
                i18n: 'custom_fields',
                slug: 'configuration.members.custom_fields'
              }
            ]
          },
          {
            url    : null,
            name   : 'Consultations',
            i18n   : 'consultation',
            slug: 'configuration.consultation',
            submenu: [
              {
                url : '/configuration/consultation/inquiry',
                name: 'Inquiry',
                i18n: 'inquiry',
                slug: 'configuration.consultation.inquiry'
              },
              {
                url : '/configuration/consultation/department',
                name: 'Department',
                i18n: 'department',
                isPlural: true,
                slug: 'configuration.consultation.department'
              },
              {
                url : '/configuration/consultation/big',
                name: 'Big',
                i18n: 'big',
                slug: 'configuration.members.big'
              },
              {
                url : '/configuration/consultation/small',
                name: 'Small',
                i18n: 'small',
                slug: 'configuration.members.small'
              },
              {
                url : '/configuration/consultation/custom-fields',
                name: 'Custom Fields',
                i18n: 'custom_fields',
                slug: 'configuration.members.custom_fields'
              }
            ]
          },
          {
            url    : null,
            name   : 'Inbound',
            i18n   : 'inbound',
            slug: 'configuration.inbound',
            submenu: [
              {
                url : '/configuration/inbound/ring-group',
                name: 'Ring Group',
                i18n: 'ring_group',
                slug: 'configuration.inbound.ringGroup'
              },
              {
                url : '/configuration/inbound/ivr',
                name: 'Ivr',
                i18n: 'ivr',
                slug: 'configuration.inbound.ivr'
              },
              {
                url : '/configuration/inbound/callback-group',
                name: 'Custom Fields',
                i18n: 'callback_group',
                slug: 'configuration.inbound.callbackGroup'
              }
            ]
          },
          {
            url    : null,
            name   : 'Tasks',
            i18n   : 'tasks',
            slug: 'configuration.task',
            submenu: [
              {
                url : '/configuration/task/category',
                name: 'Category',
                i18n: 'category',
                slug: 'configuration.task.category'
              }
            ]
          },
          {
            url    : null,
            name   : 'Custom Table',
            i18n   : 'custom_table',
            slug: 'configuration.custom_tables',
            submenu: [
              {
                url : '/configuration/custom-tables/members',
                name: 'Custom Table',
                i18n: 'members',
                slug: 'configuration.custom_tables.members'
              },
              {
                url : '/configuration/custom-tables/consultations',
                name: 'Custom Table',
                i18n: 'consultation',
                isPlural: true,
                slug: 'configuration.custom_tables.consultations'
              },
              {
                url : '/configuration/custom-tables/inbound-details',
                name: 'Custom Table',
                i18n: 'inbound_details',
                isPlural: true,
                slug: 'configuration.custom_tables.inbound-details'
              },
              {
                url : '/configuration/custom-tables/outbound-details',
                name: 'Custom Table',
                i18n: 'outbound_details',
                isPlural: true,
                slug: 'configuration.custom_tables.outbound-details'
              }
            ]
          }
        ]
      },
      {
        url    : '/slogan',
        name   : 'Slogan',
        icon   : 'ListIcon',
        i18n   : 'slogan',
        slug: 'slogan',
        permission: 'slogan',
        companyPermission: 'company_can_use_slogan'
      },
      {
        url : '/users',
        name: 'Manage Users',
        icon: 'UserIcon',
        i18n: 'manage_users',
        slug: 'user.manage',
        permission: 'manage_users',
        companyPermission: 'company_can_use_manage_users'
      },
      {
        url    : null,
        name   : 'Messages',
        isPlural: true,
        icon   : 'MessageCircleIcon',
        i18n   : 'message',
        permission: 'sms',
        companyPermission: 'company_can_manage_messages',
        submenu: [
          {
            url : '/messages/history',
            name: 'History',
            i18n: 'history',
            slug: 'messages.history'
          },
          {
            url : '/messages/category',
            name: 'Category',
            i18n: 'category',
            slug: 'messages.category'
          },
          {
            url : '/messages/callback-number',
            name: 'Callback Number',
            i18n: 'callback_number',
            slug: 'messages.callbackNumber'
          },
          {
            url : '/messages/template',
            name: 'Template',
            i18n: 'template',
            isPlural: true,
            slug: 'messages.template'
          }
        ]
      },
      {
        url : '/time-conditions',
        name: 'Time Conditions',
        icon: 'ClockIcon',
        i18n: 'time_conditions',
        slug: 'time-conditions',
        permission: 'set_working_hours',
        companyPermission: 'company_can_manage_time_conditions'
      },
      {
        url : '/fax',
        name: 'Fax',
        icon: 'PaperclipIcon',
        i18n: 'fax',
        slug: 'fax',
        permission: 'fax',
        companyPermission: 'company_can_manage_fax'
      },
      {
        url : '/transfers',
        name: 'Transfers',
        icon: 'LogInIcon',
        isPlural: true,
        i18n: 'transfer',
        slug: 'transfers',
        permission: 'transfer',
        companyPermission: 'company_can_use_transfer'
      },
      {
        url     : null,
        name    : 'Consultations',
        isPlural: true,
        icon    : 'ListIcon',
        i18n    : 'consultation',
        permission: 'consultations',
        companyPermission: 'company_can_use_consultations',
        submenu : [
          {
            url : '/consultations/consultations',
            name: 'Consultations',
            i18n: 'consultation',
            isPlural: true,
            slug: 'consultations.consultations'
          },
          {
            url : '/consultations/callbacks',
            name: 'Callbacks',
            i18n: 'callbacks',
            slug: 'consultations.callbacks',
            permission: 'call_back'
          }
        ]
      },
      {
        url : '/members',
        name: 'Members',
        icon: 'UsersIcon',
        isPlural: true,
        i18n: 'members',
        slug: 'members',
        permission: 'members',
        companyPermission: 'company_can_use_members'
      },
      {
        url    : null,
        name   : 'My Account',
        icon   : 'UserIcon',
        i18n   : 'my_account',
        permission: 'my_account',
        companyPermission: 'company_can_use_my_account',
        submenu: [
          {
            url : '/my-account/personal-information',
            name: 'Personal Information',
            i18n: 'personal_information',
            slug: 'my-account.personal-information'
          },
          {
            url : '/my-account/change-password',
            name: 'Change Password',
            i18n: 'change_password',
            slug: 'my-account.change-password'
          }
        ]
      },
      {
        url : '/tasks',
        name: 'Tasks',
        icon: 'ListIcon',
        isPlural: true,
        i18n: 'tasks',
        slug: 'tasks',
        permission: 'tasks',
        companyPermission: 'company_can_use_task'
      },
      {
        url : '/projects',
        name: 'Projects',
        icon: 'FolderIcon',
        isPlural: true,
        i18n: 'project',
        slug: 'projects',
        permission: 'projects',
        companyPermission: 'company_can_use_projects'
      },
      {
        url : '/queues',
        name: 'Queues',
        icon: 'ListIcon',
        isPlural: true,
        i18n: 'queues',
        slug: 'queues',
        permission: 'menu_queue_status',
        companyPermission: 'company_can_use_queues'
      },
      {
        url    : null,
        name   : 'Call Statistics',
        icon   : 'ActivityIcon',
        i18n   : 'call_statistics',
        companyPermission: 'company_can_use_call_statistics',
        submenu: [
          {
            url : '/call-statistics/inbound-details',
            name: 'Inbound Details',
            i18n: 'inbound_details',
            permission: 'inbound_details',
            slug: 'callStatistics.inboundDetails'
          },
          {
            url : '/call-statistics/outbound-details',
            name: 'Outbound Details',
            i18n: 'outbound_details',
            permission: 'outbound_details',
            slug: 'callStatistics.outboundDetails'
          },
          {
            url : '/call-statistics/inbound-statistics',
            name: 'Inbound Statistics',
            i18n: 'inbound_statistics',
            permission: 'inbound_statistics',
            slug: 'callStatistics.inboundStatistics'
          },
          {
            url : '/call-statistics/call-statistics',
            name: 'Call Statistics',
            i18n: 'call_statistics',
            permission: 'call_statistics',
            slug: 'callStatistics.callStatistics'
          },
          {
            url    : '/call-statistics/extension-status-data-analysis',
            name   : 'Extension Status Data Analysis',
            i18n   : 'extension_status_data_analysis',
            permission: 'extension_status_data_analysis',
            slug: 'callStatistics.extensionStatusDataAnalysis'
          }
        ]
      },
      {
        url    : '/external-link/recording-manager',
        name   : 'Recording Manager',
        icon   : 'ExternalLinkIcon',
        i18n   : 'recording_manager',
        eventBus: 'initExternalLinkToRecordingManager',
        permission: 'recording_manager',
        companyPermission: 'company_can_use_recording_manager'
      },
      {
        url    : null,
        name   : 'Message Management',
        icon   : 'ListIcon',
        i18n   : 'message_management',
        permission: 'message_management',
        companyPermission: 'company_can_use_message_management',
        submenu: [
          {
            url : '/message-management/sent-history',
            name: 'Sent History',
            i18n: 'sent_history',
            slug: 'message-management.sent-history'
          },
          {
            url : '/message-management/received-history',
            name: 'Received History',
            i18n: 'received_history',
            slug: 'message-management.received-history'
          }
        ]
      },
      // {
      //   url    : '/message-management',
      //   name   : 'Message Management',
      //   icon   : 'ListIcon',
      //   i18n   : 'message_management',
      //   slug: 'message-management',
      //   tag    : '',
      //   tagColor: 'primary',
      //   permission: 'message_management',
      //   companyPermission: 'company_can_use_message_management'
      // },
      {
        url : '/schedules',
        name: 'Schedules',
        icon: 'ListIcon',
        i18n: 'schedules',
        slug: 'schedules',
        permission: 'menu_schedules',
        companyPermission: 'company_can_schedule_push_notification'
      },
      {
        url    : '/upload-sound-file',
        name   : 'Upload Sound File',
        icon   : 'ListIcon',
        i18n   : 'upload_sound_file',
        slug: 'upload-sound-file',
        permission: 'upload_sound_file',
        companyPermission: 'company_can_upload_sound_file'
      },
      {
        url    : '/auto-call-system',
        name   : 'Auto call system',
        icon   : 'ListIcon',
        i18n   : 'auto_call_system',
        slug: 'auto-call-system',
        companyPermission: 'company_can_auto_call_system'
      },
      {
        url    : '/auto-call-system/public',
        name   : 'Auto call system (Public)',
        icon   : 'ListIcon',
        i18n   : 'auto_call_system_public',
        slug: 'auto-call-system-public',
        companyPermission: 'company_can_auto_call_system_public'
      },
      {
        url    : '/agent-api-key',
        name   : 'Agent API Key',
        icon   : 'ListIcon',
        i18n   : 'agent_api_key',
        slug: 'agent-api-key',
        permission: 'company',
        companyPermission: 'company_can_provide_agent_api'
      },
      {
        url    : '/branch-extension',
        name   : 'Branch Extension',
        icon   : 'ListIcon',
        i18n   : 'branch_extension',
        slug: 'branch-extension',
        permission: 'branch_extension',
        companyPermission: 'company_can_use_branch_extension'
      },
      {
        url    : '/blacklist',
        name   : 'Blacklist',
        icon   : 'ListIcon',
        i18n   : 'blacklist',
        permission: 'blacklist',
        companyPermission: 'company_can_use_blacklist'
      }
    ]
  }

]
